import * as types from '../../constants/modal-types';
import DiscardPostModal from '../discard-post-modal';
import PostCreateModal from '../post-create-modal';
import ChangePostCategory from '../change-post-category-modal';
import MovePost from '../move-post-modal';
import DeleteComment from '../delete-comment-modal';
import DeletePost from '../delete-post-modal';
import DemoModal from '../demo-modal';
import ReportComment from '../report-comment-modal';
import ReportPost from '../report-post-modal';
import SharePost from '../share-post-modal';
import ShareLinkModal from '../share-link-modal';
import ShareComment from '../share-comment-modal';
import ReportMemberModal from '../report-member-modal';
import PromoteMemberModal from '../promote-moderator-modal';
import DemoteMemberModal from '../demote-moderator-modal';
import UnfollowMemberModal from '../unfollow-member-modal';
import BlockMemberModal from '../block-member-modal';
import UnblockMemberModal from '../unblock-member-modal';
import DeleteCategoryModal from '../delete-category-modal';
import ProfileActionsWidget from '../profile-actions-widget';
import ProfileActionsUpperPart from '../profile-actions-upper-part';
import Login from '../login-modal';
import TextEditorLinkModal from '../text-editor-link-modal';
import TextEditorVideoEmbedModal from '../text-editor-video-embed-modal';

export default {
  [types.MODAL_TYPE_DISCARD_POST]: DiscardPostModal,
  [types.MODAL_TYPE_CREATE_POST]: PostCreateModal,
  [types.MODAL_TYPE_CHANGE_CATEGORY]: ChangePostCategory,
  [types.MODAL_TYPE_DELETE_COMMENT]: DeleteComment,
  [types.MODAL_TYPE_DELETE_POST]: DeletePost,
  [types.MODAL_TYPE_DELETE_CATEGORY]: DeleteCategoryModal,
  [types.MODAL_TYPE_MOVE_POST]: MovePost,
  [types.MODAL_TYPE_REPORT_COMMENT]: ReportComment,
  [types.MODAL_TYPE_REPORT_POST]: ReportPost,
  [types.MODAL_TYPE_REPORT_MEMBER]: ReportMemberModal,
  [types.MODAL_TYPE_PROMOTE_MODERATOR]: PromoteMemberModal,
  [types.MODAL_TYPE_DEMOTE_MODERATOR]: DemoteMemberModal,
  [types.MODAL_TYPE_UNFOLLOW_MEMBER]: UnfollowMemberModal,
  [types.MODAL_TYPE_BLOCK_MEMBER]: BlockMemberModal,
  [types.MODAL_TYPE_UNBLOCK_MEMBER]: UnblockMemberModal,
  [types.MODAL_TYPE_SHARE_POST]: SharePost,
  [types.MODAL_TYPE_SHARE_LINK]: ShareLinkModal,
  [types.MODAL_TYPE_SHARE_COMMENT]: ShareComment,
  [types.MODAL_TYPE_LOGIN]: Login,
  [types.MODAL_TYPE_PROFILE_ACTIONS]: ProfileActionsWidget,
  [types.MODAL_TYPE_PROFILE_ACTIONS_UPPER_PART]: ProfileActionsUpperPart,
  [types.MODAL_TYPE_TEXT_EDITOR_LINK]: TextEditorLinkModal,
  [types.MODAL_TYPE_TEXT_EDITOR_VIDEO_EMBED]: TextEditorVideoEmbedModal,
  [types.MODAL_TYPE_DEMO_MODE]: DemoModal,
};



// WEBPACK FOOTER //
// ./app/containers/modal-root/modals.js